import React from "react";
import {formatDateRangePretty} from "crqlar-react-common/dist/utils/date.util";
import {getValidDateTimeValue} from "./utils";

export function StayRangeElement({
                             start,
                             end,
                             locale,
                         }: {
    start: string | Date | undefined;
    end: string | Date | undefined;
    locale: string;
}) {
    if (!start || !end) {
        return null;
    }

    const startDate = getValidDateTimeValue(start);
    const endDate = getValidDateTimeValue(end);

    if (!startDate || !endDate) {
        return null;
    }

    return <>{formatDateRangePretty(startDate, endDate, locale)}</>;
}
